{
	"ariaEditMoreMenu": "Edit More Menu",
	"ariaEditorLeftPanelGroup": "Editor Left Panel Group",
	"ariaExpandedPanel": "expanded panel",
	"ariaLeftCullingPanelGroup": "Left Culling Panel Group",
	"ariaOpenUndoRedoCopyPasteActionsList": "Open Undo/Redo/Copy/Paste Actions List",
	"ariaPhotoFullscreenViewport": "Photo Fullscreen Viewport",
	"ariaProject": "project",
	"ariaResetAdjustments": "Reset Adjustments",
	"ariaRightCullingPanelGroup": "Right Culling Panel Group",
	"ariaToggleLeftPanelGroup": "Toggle Left Panel Group",
	"ariaToggleRightPanelGroup": "Toggle Right Panel Group",
	"copyEdits": "Copy Edits",
	"labelRightPanelGroupResizer": "Right Panel Group Resizer",
	"panelHistogram": "Histogram",
	"panelHistory": "History",
	"panelSmartCulling": "Smart Culling",
	"pasteEdits": "Paste Edits",
	"redo": "Redo",
	"resetAll": "Reset All",
	"undo": "Undo"
}
